import moment from "moment";
import { readContract, getAccount, getChainId, } from "wagmi/actions";
import * as contracts from "@contracts";
import { wagmiConfig, } from "@config";
import { getConnectionInfo } from "@helpers";
import { getChainedTokens, type TokenDefinition, } from "@bracket/addressbook";



/** get all wallet balances for all tokens on the current chain.
 * @todo make chain an optional argument, allowing retrieval of balances from an unconnected chain */
export const getAvailables = async ({
	force = false,
}: {
	force?: boolean;
}): Promise<Record<TokenDefinition["label"], bigint>> => {
	const {
		address,
		chain:accountChain,
	} = getAccount(wagmiConfig);
	const chain = accountChain?.id;
	if(chain) {
		const result = {} as Record<TokenDefinition["label"], bigint>;
		const tokens = getChainedTokens(chain, { includeETH: false, });
		for( const token of tokens ) {
			const value = await getAvailable({ token, force, });
			result[token.label] = value;
		}
		return result;
	}
}



/** get wallet balances for a given token on the current chain.
 * @param {TokenDefinition} 
 * @todo make chain an optional argument, allowing retrieval of balances from an unconnected chain */
export const getAvailable = async ({
	token,
	attempt = 0,
	force = false,
}: {
	token: TokenDefinition;
	attempt?: number;
	force?: boolean;
}): Promise<bigint> => {
	try {

		const now = moment().unix();
		const cached = availablesCache.get(token.symbol);

		if(!force) {
			if(cached) {
				const { since, value, } = cached;
				if(now - since < availablesTTL) {
					return value;
				}
			}
		}

		const amount = await readContract(wagmiConfig, contracts.ERC20.balanceOfCore({ token, }));
		if( typeof amount === "bigint" ) {
			availablesCache.set(token.symbol, { since: now, value: amount, });
			return amount;
		}

		throw new Error("state::resolvers::getAvailable failed getting user balance");

	}
	catch(err) {
 		if( attempt < 3 ) {
			return await getAvailable({
				token,
				attempt: attempt+1,
			});
		}
		throw new Error(`EscrowStore::getAvailable failed getting a user balance for token ${token.label} - ${err instanceof Error ? err.message : "no error instance" }` );
	}

}

const availablesCache = new Map<TokenDefinition["symbol"], { since: number, value: bigint, }>();
const availablesTTL = 15; // 60 seconds.

